module.exports = __webpack_public_path__ + "img/electric_enabled.11763d7c.svg";